import { BaseAddresViewModel } from './BaseAddress';
import { GeneralInfo } from './GeneralInfo';
import { NewspaperInfo } from './NewspaperInfo';
import { NotificationInfo } from './NotificationInfo';

export class SearchByVinViewModel
{
    vehicleInfo:GeneralInfo;
    storageInfo:BaseAddresViewModel;
    pickupInfo:BaseAddresViewModel;   
    billingInfo:BaseAddresViewModel;
    notices:Array<NotificationInfo>;
    newspaperPosts:Array<NewspaperInfo>;
    companyName:string;
    privateTow:boolean;
    isSearched:boolean;
    constructor() {
        this.isSearched=false;
        this.vehicleInfo = new GeneralInfo();
        this.storageInfo= new BaseAddresViewModel();
        this.pickupInfo = new BaseAddresViewModel();
        this.billingInfo = new BaseAddresViewModel();
        this.notices = new Array<NotificationInfo>();
        this.newspaperPosts = new Array<NewspaperInfo>();
        this.companyName = "";
        this.privateTow = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/ViewModels/TowLocateViewModels/SerchbyVinViewModel.ts